import Vuex from 'vuex'
import { APP_CHANNEL, URL_PARAM, getUrlParams } from '@/common/utils/variables.js'
import { getThemeList } from '@/api/theme.js'
import { getUser } from '@/api/index.js'
import { getUserPlanBookMemberInfo } from '../js/api.js'
import { updateThemeVariables } from '@/config/theme.js'

const store = new Vuex.Store({
  state: {
    appPlatform: APP_CHANNEL,
    interestData: null,
    memberInfo: null,
    themeList: null,
    userInfo: null
  },
  mutations: {
    updateAppPlatform (state, name = '') {
      state.appPlatform = name
    },
    SET_INTEREST_DATA (state, data) {
      if (!data) {
        return
      }
      state.interestData = {
        ...(state.interestData || {}),
        ...data
      }
    },
    SET_MEMBER_INFO (state, data) {
      state.memberInfo = data
    },
    SET_THEME_LIST (state, data) {
      state.themeList = data
    },
    SET_USER_INFO (state, data) {
      state.userInfo = data
    }
  },
  actions: {
    // 获取会员信息
    async getMemberInfo ({ commit }) {
      try {
        const {data} = await getUserPlanBookMemberInfo()
        console.log('获取会员信息', data)
        if (data && data.success && data.data) {
          commit('SET_MEMBER_INFO', data.data)
          return data.data
        }
        return null
      } catch (error) {
        console.error('获取会员信息失败:', error)
        return null
      }
    },
    getThemeList ({ commit }) {
      const { theme } = getUrlParams();
      return getThemeList().then(data => {
        updateThemeVariables(theme, data)
        commit('SET_THEME_LIST', data)
      })
    },
    async setUserInfo ({ commit }) {
      try {
        const res = await getUser()
        const userInfo = res?.data?.data ?? res?.data
        console.log('获取用户信息', userInfo)
        if (userInfo) {
          commit('SET_USER_INFO', userInfo)
          return userInfo
        }
        return null
      } catch (error) {
        console.error('获取用户信息失败:', error)
        return null
      }
    }
  }
})

export default store
